"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_geocoder_1 = __importDefault(require("./abstract-geocoder"));
var generateLabel = function (properties) {
    var propertyList = [];
    ["name", "street", "district", "state", "postcode", "city", "country"].forEach(function (propertyName) {
        if (typeof properties[propertyName] === "undefined") {
            return;
        }
        var value = "".concat(properties[propertyName]);
        if (value.length > 0) {
            propertyList.push(value);
        }
    });
    return propertyList.join(", ");
};
/**
 * Geocoder implementation for the Photon geocoder.
 * See https://photon.io
 *
 * @extends Geocoder
 */
var PhotonGeocoder = /** @class */ (function (_super) {
    __extends(PhotonGeocoder, _super);
    function PhotonGeocoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PhotonGeocoder.prototype.getAutocompleteQuery = function (query) {
        var _a = this.geocoderConfig, baseUrl = _a.baseUrl, boundary = _a.boundary, focusPoint = _a.focusPoint, options = _a.options, size = _a.size;
        return __assign({ boundary: boundary, focusPoint: focusPoint, options: options, size: size, url: baseUrl ? "".concat(baseUrl, "/api") : undefined }, query);
    };
    PhotonGeocoder.prototype.getSearchQuery = function (query) {
        var _a = this.geocoderConfig, baseUrl = _a.baseUrl, boundary = _a.boundary, focusPoint = _a.focusPoint, options = _a.options, size = _a.size;
        return __assign({ boundary: boundary, focusPoint: focusPoint, options: options, size: size, url: baseUrl ? "".concat(baseUrl, "/api") : undefined }, query);
    };
    PhotonGeocoder.prototype.rewriteAutocompleteResponse = function (response) {
        response.features.forEach(function (value) {
            value.properties.label = generateLabel(value.properties);
        });
        return response;
    };
    /**
     * Rewrite the response into an application-specific data format using the
     * first feature returned from the geocoder.
     */
    PhotonGeocoder.prototype.rewriteReverseResponse = function (response) {
        var _a;
        if ((_a = this.geocoderConfig) === null || _a === void 0 ? void 0 : _a.reverseUseFeatureCollection) {
            response.features.forEach(function (value) {
                value.properties.label = generateLabel(value.properties);
            });
            return response;
        }
        var _b = response.point, lat = _b.lat, lon = _b.lon;
        var firstFeature = response.features[0];
        return {
            lat: lat,
            lon: lon,
            name: generateLabel(firstFeature.properties),
            rawGeocodedFeature: firstFeature
        };
    };
    PhotonGeocoder.prototype.rewriteSearchResponse = function (response) {
        return this.rewriteAutocompleteResponse(response);
    };
    return PhotonGeocoder;
}(abstract_geocoder_1.default));
exports.default = PhotonGeocoder;
//# sourceMappingURL=photon.js.map